import React from "react";
import { $t } from '@/modules/i18n';

import faqup from '@uh/assets/images/faqup.png';

const FaqItem = ({ item, id, index }) => {
  return <div className="row">
    <div className="col-md-8 offset-md-2">
      <a className="question" data-toggle="collapse" href={`#${id}` + index + 1} role="button" data-target={`#${id}` + index + 1} aria-expanded="false" aria-controls="collapseOne">
        <span className="question-text">
          <b>Q{index + 1}:</b>
          {$t(item.question)}
        </span>
      </a>
      <div id={id + index + 1} className="collapse card-body" aria-labelledby="headingOne" data-parent="#faq">
        {
          Array.isArray(item.answer)
          ? item.answer.map(answer => <p className="desc" key={answer} dangerouslySetInnerHTML={{ __html: $t(answer) }}></p>)
          : <p className="desc" dangerouslySetInnerHTML={{ __html: $t(item.answer) }}></p>
        }
      </div>
    </div>
  </div >
}

const Faq = ({ Message: msg }) => {
  const list = [{
    id: 'faq-a',
    title: msg.faqTitle01,
    datas: msg.faqData01
  }, {
    id: 'faq-b',
    title: msg.faqTitle02,
    datas: msg.faqData02
  }, {
    id: 'faq-c',
    title: msg.faqTitle03,
    datas: msg.faqData03
  }, {
    id: 'faq-d',
    title: msg.faqTitle04,
    datas: msg.faqData04
  }, {
    id: 'faq-e',
    title: msg.faqTitle05,
    datas: msg.faqData05
  }]

  return (
    <section id="faq">
      <div className="container">
        <div className="title-block">
          <h2>{$t(msg.faq)}</h2>
        </div>
        {
          list.map((section, i) => (
            <div key={i}>
              <h4 className="col-md-8 offset-md-2"><img className="faq-icon" src={faqup} alt="faq icon" />{$t(section.title)}</h4>
              {
                section.datas.map((item, index) => {
                  return <FaqItem key={index} item={item} id={section.id} index={index} />
                })
              }
            </div>
          ))
        }
      </div>
    </section>
  )
}

export default Faq;